import React from 'react';
import { Box, Typography, Chip, IconButton } from '@mui/material';
import CallEndIcon from '@mui/icons-material/CallEnd';
import CloseIcon from '@mui/icons-material/Close';

const Practice = () => {
  return (
    <Box sx={{ p: 3, height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Close button */}
      <IconButton 
        sx={{ 
          position: 'absolute', 
          top: 16, 
          left: 16,
          color: 'black',
        }}
      >
        <CloseIcon />
      </IconButton>

      {/* Header with tags */}
      <Box sx={{ display: 'flex', gap: 2, mb: 2, mt: 4 }}>
        <Chip label="實戰演練" />
        <Chip label="保險業" />
        <Chip label="難度：中高級" />
      </Box>

      {/* Main content area */}
      <Box 
        sx={{ 
          flex: 1,
          position: 'relative',
          borderRadius: 2,
          overflow: 'hidden',
          backgroundColor: '#F8F8F8',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/* Phone container */}
        <Box sx={{
          width: '100%',
          maxWidth: '600px',
          height: '80vh',
          display: 'flex',
          borderRadius: 16,
          overflow: 'hidden',
          boxShadow: '0px 4px 20px rgba(0,0,0,0.15)',
          position: 'relative', // Added position relative
        }}>
          {/* Phone content */}
          <Box sx={{
            flex: 1,
            backgroundColor: '#FFFFFF',
            position: 'relative',
          }}>
            <img 
              src="https://api.dicebear.com/7.x/avataaars/svg?seed=4419&backgroundColor=b6e3f4" 
              alt="Avatar" 
              style={{ 
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }} 
            />

            {/* Call control button - Moved inside phone container */}
            <Box sx={{ 
              position: 'absolute',
              bottom: 20,
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 2,
            }}>
              <IconButton
                sx={{
                  backgroundColor: '#D32F2F',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#B71C1C'
                  },
                  width: 64,
                  height: 64,
                  boxShadow: '0px 4px 12px rgba(211, 47, 47, 0.4)',
                }}
              >
                <CallEndIcon sx={{ fontSize: 32 }} />
              </IconButton>
            </Box>
          </Box>
        </Box>

        {/* Timer and name overlay */}
        <Box 
          sx={{ 
            position: 'absolute',
            top: 16,
            left: '50%',
            transform: 'translateX(-50%)',
            color: 'white',
            zIndex: 1,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            padding: '8px 16px',
            borderRadius: 8,
            textAlign: 'center', // Center text
            width: 'auto',
            minWidth: '200px',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 500 }}>陳國平，70 歲</Typography>
          <Typography sx={{ opacity: 0.9 }}>00:02</Typography>
        </Box>

        {/* Thinking indicator */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 100, // Moved up to make room for call button
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            padding: '12px 32px',
            borderRadius: 30,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            boxShadow: '0px 2px 12px rgba(0,0,0,0.15)',
          }}
        >
          <Typography>思考中...</Typography>
          <Box sx={{ 
            display: 'flex', 
            gap: 0.5 
          }}>
            {[...Array(5)].map((_, i) => (
              <Box
                key={i}
                sx={{
                  width: 4,
                  height: 4,
                  backgroundColor: 'black',
                  borderRadius: '50%',
                }}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Practice; 